type LiikenneLangTermMap = {
    [key: string]: string;
}

const liikenneLangTerms: LiikenneLangTermMap = {
    ajokorttijalupapalvelupiste: "App.TieLiikenne.AjokorttiJaLupapalvelupiste",
    rekisterointitoimipaikka: "App.TieLiikenne.AjoneuvojenRekisterointitoimipaikka",
    yleisetpisteet: "App.VesiLiikenne.yleisetpisteet",
    omatrekisteroinnit: "App.VesiLiikenne.omatrekisteroinnit"
}

function getLiikenneLangTerm(term: string): string {
    return liikenneLangTerms[term]
}

export { getLiikenneLangTerm }
